<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link class="btn btn-sm" :to="{ name: 'PBRMappingList' }">
                <i class="fas fa-chevron-left"></i>
              </router-link>
              PBR Mapping
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">PBR Mapping</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="PBRMapping">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header py-3">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <div class="form-row">
                    <div v-if="organizationId == 1" class="col-sm form-group required">
                      <label class="control-label">Audra</label>
                      <input
                        v-if="is_edit"
                        type="text"
                        v-model="pre.audraName[value.accountId]"
                        id="accountId"
                        class="form-control accountId"
                        name="accountId"
                        readonly
                      />
                      <multiselect
                        v-else
                        v-model="value.accountId"
                        :options="Object.keys(pre.audraName)"
                        :custom-label="(opt) => pre.audraName[opt]"
                        placeholder="Select Audra Name"
                        :searchable="true"
                        :multiple="false"
                        id="accountId"
                        v-bind:class="{ 'has-error': errors.has('accountId') }"
                        v-validate="'required'"
                        name="accountId"
                      >
                      </multiselect>
                      <div class="help text-danger" v-show="errors.has('accountId')">
                        {{ errors.first("accountId") }}
                      </div>
                    </div>

                    <div class="col-sm form-group required">
                      <label class="control-label">PBR Name</label>
                      <input
                        type="text"
                        id="pbr_name"
                        name="pbr_name"
                        v-bind:class="{ 'has-error': errors.has('pbr_name') }"
                        v-validate="{ required: true, regex: /^\w+$/ }"
                        v-model="value.pbr_name"
                        class="form-control pbr_name"
                        placeholder="PBR Name"
                      />
                      <div class="help text-danger" v-show="errors.has('pbr_name')">
                        {{ `The pbr name required in proper alphabets.` }}
                      </div>
                    </div>

                    <div class="col-sm form-group required">
                      <label class="control-label">Interface</label>
                      <multiselect
                        v-model="value.interface_name"
                        :options="Object.keys(interfaceName)"
                        :custom-label="
                          (opt) => {
                            return interfaceName[opt] ? interfaceName[opt] : '';
                          }
                        "
                        placeholder="Select Interface Name"
                        :searchable="true"
                        :multiple="false"
                        id="interface_name"
                        v-bind:class="{
                          'has-error': errors.has('interface_name'),
                        }"
                        v-validate="'required'"
                        name="interface_name"
                      >
                      </multiselect>
                      <div class="help text-danger" v-show="errors.has('interface_name')">
                        {{ `The interface field is required` }}
                      </div>
                    </div>
                  </div>

                  <h4
                    class="card-common-title p-0 mb-2"
                    :class="{
                      'pb-2 border-bottom': !details.length > 0,
                    }"
                  >
                    Details
                  </h4>

                  <div class="w-full mt-4 p-10">
                    <div v-for="(detail, index) in details" :key="index" class="">
                      <div class="form-row">
                        <div class="form-group col-sm">
                          <label class="control-label">Sequence</label>
                          <input
                            type="text"
                            :id="'sequence_' + index"
                            :name="'sequence_' + index"
                            v-validate="{
                              required: true,
                              regex: /^[1-9][0-9]*$/,
                            }"
                            v-bind:class="{
                              'has-error': errors.has('sequence_' + index),
                            }"
                            v-model="detail.sequence"
                            class="form-control sequence"
                            placeholder="Sequence"
                          />
                          <div
                            class="help text-danger"
                            v-show="errors.has('sequence_' + index)"
                          >
                            {{ `The sequence is invalid.` }}
                          </div>
                        </div>

                        <div class="form-group col-sm">
                          <label class="control-label">Source</label>
                          <input
                            type="text"
                            :id="'source_' + index"
                            :name="'source_' + index"
                            v-bind:class="{
                              'has-error': errors.has('source_' + index),
                            }"
                            v-model="detail.source"
                            class="form-control source"
                            placeholder="192.168.20.0/24"
                            v-validate="'required|ip_CIDR'"
                          />
                          <div
                            class="help text-danger"
                            v-show="errors.has('source_' + index)"
                          >
                            {{
                              `The input format is invalid. Valid Format : 192.168.20.0/24`
                            }}
                          </div>
                        </div>
                        <div class="form-group col-sm">
                          <label class="control-label">Destination</label>
                          <input
                            type="text"
                            :id="'destination_' + index"
                            :name="'destination_' + index"
                            v-bind:class="{
                              'has-error': errors.has('destination_' + index),
                            }"
                            v-model="detail.destination"
                            class="form-control source"
                            placeholder="103.218.25.0/24"
                            v-validate="'required|ip_CIDR_dest'"
                          />
                          <div
                            class="help text-danger"
                            v-show="errors.has('destination_' + index)"
                          >
                            {{
                              `The input format is invalid. Valid Format : 103.218.50.0/24`
                            }}
                          </div>
                        </div>
                        <div class="d-none form-group col-sm">
                          <label class="control-label">Nexthop Type</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="''"
                            @input="resetNextHopeValue(index)"
                            v-model="details[index].nexthop_type"
                            :options="Object.keys(pre.nexthop_type)"
                            :custom-label="(opt) => pre.nexthop_type[opt]"
                            placeholder="Nexthop Type"
                            :searchable="true"
                            :multiple="false"
                            :id="'nexthop_type' + index"
                            v-bind:class="{
                              'has-error': errors.has('nexthop_type' + index),
                            }"
                            :name="'nexthop_type' + index"
                          >
                          </multiselect>

                          <!-- <multiselect
                            :select-label="''"
                            :deselect-label="''"
                            v-model="details[index].nexthop_type"
                            :options="Object.keys(pre.nexthop_type)"
                            :custom-label="opt => pre.nexthop_type[opt]"
                            placeholder="Nexthop Type"
                            :searchable="true"
                            :multiple="false"
                            :id="'nexthop_type' + index"
                            v-validate="'required'"
                            :class="{
                              'has-error': errors.has('nexthop_type' + index)
                            }"
                            :name="'nexthop_type' + index"
                            @input="resetNextHopeValue(index)"
                          >
                          </multiselect> -->
                          <div
                            class="help text-danger"
                            v-show="errors.has('nexthop_type' + index)"
                          >
                            {{ `The nexthop type is required` }}
                          </div>
                        </div>
                        <div class="form-group col-sm">
                          <label class="control-label">Next Hop</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="'Remove'"
                            v-if="details[index].nexthop_type == 'group'"
                            v-model="detail.nexthop"
                            :options="pre.nexthop"
                            placeholder="Select Next Hop"
                            :searchable="true"
                            :multiple="false"
                            v-validate="'required'"
                            :id="'nexthop_' + index"
                            v-bind:class="{
                              'has-error': errors.has('nexthop_' + index),
                            }"
                            :name="'nexthop_' + index"
                          >
                          </multiselect>

                          <input
                            v-else
                            type="text"
                            :id="'nexthop_' + index"
                            :name="'nexthop_' + index"
                            v-bind:class="{
                              'has-error': errors.has('nexthop_' + index),
                            }"
                            v-validate="'required|ip'"
                            v-model="detail.nexthop"
                            class="form-control nexthop"
                            placeholder="NextHop IP"
                          />

                          <div
                            class="help text-danger"
                            v-show="errors.has('nexthop_' + index)"
                          >
                            <span v-if="details[index].nexthop_type == 'group'">
                              The next hop group is required.
                            </span>
                            <span v-else>
                              The next hop should be a valid IP address. Format:
                              192.168.20.100
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex justify-content-end border-bottom pb-3 mb-3">
                        <a
                          class="text-danger fw-500"
                          @click="remove(index)"
                          v-if="details.length > 1"
                        >
                          <i class="icon-trash"></i> Remove
                        </a>
                      </div>
                    </div>

                    <div class="form-group text-right">
                      <a @click.prevent="addMore()" class="pc fw-500">
                        <i class="fas fa-plus-circle"></i> New
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer pt-0 pb-4">
              <button type="submit" v-if="!is_edit" class="btn">Submit</button>
              <button type="submit" v-if="is_edit" class="btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import { CommonAPI } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "PBRMappingForm",
  metaInfo: {
    title: "PBR Mapping | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},
    value: {
      accountId: "",
      pbr_name: "",
      interface_name: "",
    },
    pre: {
      audraName: {}, // Assumed to be populated with data
      nexthop_type: { ip: "IP", group: "Group" },
      nexthop: [], // Assumed to be populated with data
    },
    interfaceName: [],
    details: [
      {
        sequence: "",
        source: "",
        destination: "",
        nexthop_type: "ip",
        nexthop: "",
      },
    ],
    nexthop_type: { ip: "IP" },
  }),

  methods: {
    handleSubmission() {
      // console.log(JSON.stringify(this.details.toString()))
      // return
      const _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.value.pbr_details = _this.details;
          _this.is_loading = true;
          let api_url = "/pbr_mapping";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/pbr_mapping/" + _this.$route.params.id;
            method = "PUT";
          }

          console.log(this.value);

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: "PBRMappingList" });
            })
            .catch((errors) => {
              if (errors.response.status === 501) {
                _this.$toaster.error(errors.response.data.errors.message);
                _this.$setErrorsFromResponse(errors.response.data.errors);
              } else if (errors.response.data) {
                _this.$toaster.error(errors.response.data.message);
                _this.$setErrorsFromResponse(errors.response.data);
              }
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },

    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/pbr_mapping/" + id;
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get("accountId") },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },

    getInterface: function () {
      return new Promise((resolve, reject) => {
        axios
          .get("/get-pbr-interface", {
            params: {
              accountId: LocalStorage.get("accountId"),
            },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },

    getNextHopGroups: function () {
      return new Promise((resolve, reject) => {
        axios
          .get("/get-nexthop-groups", {
            params: {
              accountId: LocalStorage.get("accountId"),
            },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },

    async initialize() {
      this.setCustomValidation();
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;
            this.details = this.value.pbr_details;
            this.setNexthopType();
          })
          .catch((errors) => {
            if (errors.response.status === 501) {
              this.$toaster.error(errors.response.data.errors.message);
              this.$setErrorsFromResponse(errors.response.data.errors);
            } else if (errors.response.data) {
              this.$toaster.error(errors.response.data.message);
              this.$setErrorsFromResponse(errors.response.data);
            }
            this.$router.back();
          });
      } else {
        this.value.accountId = LocalStorage.get("accountId");
      }

      await CommonAPI.getAudraName(LocalStorage.get("accountId"))
        .then((response) => {
          this.pre.audraName = response;
        })
        .catch((error) => {
          console.log(error.response);
        })
        .catch((error) => {
          console.log(error.response);
        });

      await this.getInterface()
        .then((response) => {
          this.interfaceName = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });

      await this.getNextHopGroups()
        .then((response) => {
          this.pre.nexthop = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.is_loading = false;
    },
    addMore() {
      let nextSequence = 1;
      if (this.details.length > 0) {
        nextSequence =
          Math.max(...this.details.map((detail) => parseInt(detail.sequence))) + 1;
      }

      this.details.push({
        sequence: "",
        source: "",
        destination: "",
        nexthop_type: "ip",
        nexthop: "",
      });
    },

    remove(index) {
      this.details.splice(index, 1);
    },
    resetNextHopeValue(index) {
      this.$set(this.details[index], "nexthop", "");
    },
    setCustomValidation: function () {
      this.$validator.extend("ip_CIDR", {
        getMessage: (field) =>
          "The input format is invalid. Valid Format : 192.168.20.0/24",
        validate: (value) => {
          return this.validateIpCidr(value) ? 1 : 0;
        },
      });

      this.$validator.extend("ip_CIDR_dest", {
        getMessage: (field) =>
          "The input format is invalid. Valid Format : 103.218.50.0/24",
        validate: (value) => {
          return this.validateIpCidr(value) ? 1 : 0;
        },
      });
    },

    validateIpCidr(value) {
      const ipAddressPattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\/(3[0-2]|[0-2]?[0-9])$/;
      return ipAddressPattern.test(value) ? 1 : 0;
    },

    setNexthopType() {
      const ipAddressPattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      for (let i = 0; i < this.details.length; i++) {
        if (ipAddressPattern.test(this.details[i].nexthop)) {
          this.nexthop_type[i] = "ip";
        } else {
          this.nexthop_type[i] = "group";
        }
      }
    },
  },
  mounted() {
    this.initialize();
  },
};
</script>
